import { cn } from '../../../utils/cn/cn';
import { Button, type ButtonProps } from '../../Button/Button';

export const ArrowButton = ({ children, className, ...rest }: ButtonProps) => (
  <Button
    className={cn(
      'shadow-carousel-arrow-button [&>[class^="icon-emp"]]:fill-color-text-dark hover:bg-color-grey bg-color-background-base absolute top-1/2 h-5 w-5 -translate-y-1/2 touch-manipulation rounded-full border-0 transition-colors',
      className,
    )}
    {...rest}
  >
    {children}
  </Button>
);
